<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-button class="float-right" @click="() => newOperationArea()" >{{$t('zonedArea.new')}}</b-button>
				<h2>{{$t('zonedArea.operationZones')}}</h2>
				<hr>
				<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'operation-areas-index-list') } ">
					<div class="row">
						<b-form-group class="col-md-2" :label="$t('global.search')">
							<b-form-input v-model="filters.search" type="text" />
						</b-form-group>
						<b-form-group class="col" label=".">
							<b-button type="submit" variant="primary">{{$t('global.search')}}</b-button>
						</b-form-group>
					</div>
				</b-form>
				<AjaxTable
					id="operation-areas-index-list"
					:filters="filters"
					:columns="columns"
					resource="zoned-areas"
				>
					<template v-slot:cell(actions)="row">
						<div class="text-center">
							<b-button @click="(event) => goToResource(row.item)" type="button" size="sm" class="mr-1" variant="success" v-b-tooltip.hover.left :title="$t('zonedArea.detailsAndEdit')">
								<md-icon icon="add_location_alt"></md-icon>
							</b-button>
							<b-button @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
								<md-icon icon="delete" />
							</b-button>
						</div>
					</template>
				</AjaxTable>
			</div>
		</div>
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
export default {
	components: { MainLayout, AjaxTable },
	data(){
			return {
				modalInfo : {
					modelId:-1,
				},
				filters : {
					search:'',
				},
				columns : [
					{key:'id',label:'ID'},
					{key:'name',label:this.$t('saleChannel.name')},
					{key:'status',label:this.$t('global.status')},
					{key:'actions',label:this.$t('global.actions')},
				],
			}
	},
	methods:{
		successCallback(){
			this.$root.$emit('bv::refresh::table', 'operation-areas-index-list')
		},
		goToResource(item){
			this.$router.push('/operation-area/'+item.id);
		},
		newOperationArea(){
			this.$router.push('/operation-area/new');
		},
		modelDelete(item){
			this.$bvModal
			.msgBoxConfirm(this.$t("zonedArea.confirmDelete",{saleChannel:item.name}), {
				title: this.$t("warnings.okToContinue"),
				size: "md",
				buttonSize: "md",
				okVariant: "danger",
				okTitle: this.$t("global.yes")+", "+this.$t("warnings.continue"),
				cancelTitle: "Cancel",
				footerClass: "p-2",
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if (value === true) {
					this.$root.api.delete(`/zoned-areas/${item.id}`).then(() => {
						this.$root.auxVars.loadResourcesOpts({vm: this,resourceNames: ["salesChannels"], forceRefresh: true});
						this.$root.showAlert(this.$t('global.registerDeleted'),{variant:'success'})
						this.successCallback();
						this.$root.auxVars.loadResourcesOpts({vm: this,resourceNames: ["zonedAreasOpts"], forceRefresh: true});
						close()
					}).catch( err => {
						this.$root.handleRequestError(err)
						close()
					});
				}
			})
			.catch(err => {
				console.log(err);
				// An error occurred
			});
		}
	},
	computed:{
		iconPolygons(){
			return '<svg viewBox="-2.4 -2.4 28.80 28.80" xmlns="http://www.w3.org/2000/svg"  transform="matrix(1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path class="icon-path" d="M20 3.456L12 9.28V9H9v.433l-5-3.31V4H1v3h1v13H1v3h3v-1h16v1h3v-3h-1V4h1V1h-3zM10 10h1v1h-1zM2 5h1v1H2zm0 17v-1h1v1zm20 0h-1v-1h1zm-1-2h-1v1H4v-1H3V7h.512L9 10.632V12h3v-1.483L20.952 4H21zm1-18v1h-1V2z"></path><path fill="none" d="M0 0h24v24H0z"></path></g></svg>'
		}
	},
	mounted(){
	}
}
</script>
<style scoped>
.icon {
  width: 22px;
  height: 22px;;
  fill:whitesmoke !important;

}
.icon-path {
  stroke-width: 4; /* Set the stroke width here */
  stroke: black; /* Set the stroke color */
  fill: none; /* Optional: Remove fill if needed */
}
</style>
<style>

</style>
